import { useNavigate, Link } from "react-router-dom";
import React from "react";
import OwlCarousel from 'react-owl-carousel3';
import "./NewsRoom.css";
import { SupplierCenteralHeader } from "../Header";
import { SupplierCenteralFooter } from "../Footer";

export { NewsRoom };

function NewsRoom() {

  return (
    <div>
      {/* HEADER SEC */}
      <SupplierCenteralHeader />
      {/* HEADER SEC */}

      <div className="news-room-body d-flex">
        <div className="news-info-sec">

          <OwlCarousel className="news-hero-slider owl-theme" loop margin={10} nav dots={false} items={1} autoplay={false} autoplayHoverPause={false} smartSpeed={1500} autoplayTimeout={2500}>
            <div className="news-slider-item">
              <div className="news-hero-img">
                <img src="/images/news-img-1.jpeg" alt="" />
              </div>
              <div className="news-hero-overlay">
                <a href="#" className="news-share"><span className="material-symbols-outlined">send</span> Share</a>
                <div className="news-category-name"><span className="material-symbols-outlined">ballot</span> Relevant to Coles Liquor</div>
                <div className="news-title">Coles Liquor BevChain NSW DC Transition</div>
                <div className="news-ul">
                  <div className="news-li"><span className="material-symbols-outlined">person</span> Helena Thomton</div>
                  <div className="news-li"><span className="material-symbols-outlined">event_available</span> 04/08/2024</div>
                  <div className="news-li"><span className="material-symbols-outlined">visibility</span> 240 Views</div>
                </div>
              </div>
            </div>
            <div className="news-slider-item">
              <div className="news-hero-img">
                <img src="/images/news-img-2.jpeg" alt="" />
              </div>
              <div className="news-hero-overlay">
                <a href="#" className="news-share"><span className="material-symbols-outlined">send</span> Share</a>
                <div className="news-category-name"><span className="material-symbols-outlined">ballot</span> Relevant to Coles Liquor</div>
                <div className="news-title">Coles Liquor BevChain NSW DC Transition</div>
                <div className="news-ul">
                  <div className="news-li"><span className="material-symbols-outlined">person</span> Helena Thomton</div>
                  <div className="news-li"><span className="material-symbols-outlined">event_available</span> 04/08/2024</div>
                  <div className="news-li"><span className="material-symbols-outlined">visibility</span> 240 Views</div>
                </div>
              </div>
            </div>
            <div className="news-slider-item">
              <div className="news-hero-img">
                <img src="/images/news-img-3.jpeg" alt="" />
              </div>
              <div className="news-hero-overlay">
                <a href="#" className="news-share"><span className="material-symbols-outlined">send</span> Share</a>
                <div className="news-category-name"><span className="material-symbols-outlined">ballot</span> Relevant to Coles Liquor</div>
                <div className="news-title">Coles Liquor BevChain NSW DC Transition</div>
                <div className="news-ul">
                  <div className="news-li"><span className="material-symbols-outlined">person</span> Helena Thomton</div>
                  <div className="news-li"><span className="material-symbols-outlined">event_available</span> 04/08/2024</div>
                  <div className="news-li"><span className="material-symbols-outlined">visibility</span> 240 Views</div>
                </div>
              </div>
            </div>
          </OwlCarousel>

          <div className="news-listing-filter">
            <div className="news-search">
              <input type="search" className="form-control" placeholder="Search..." />
              <button type="button" className="search-btn"><img src="/images/search-icon.svg" alt="" /></button>
            </div>
            <div className="news-filter-list">
              <div className="show-item">Showing 24 of 240 Items</div>
              <div className="show-dropdown">
                <span>Per Page</span>
                <select className="form-control">
                  <option>12</option>
                  <option>24</option>
                  <option>36</option>
                </select>
              </div>
              <div className="short-by">
                <span>Sort by:</span>
                <select className="form-control">
                  <option>Popularity</option>
                  <option>Latest Post</option>
                  <option>A-Z</option>
                  <option>Z-A</option>
                </select>
              </div>
            </div>
          </div>

          <div className="news-listing-sec">
            {/*---SIDEBAR---*/}
            <div className="news-listing-type">
              <ul className="p-0">
                <li>
                  <button type="button" className="nl-type-btn">Coles Business Brands <span className="material-symbols-outlined">keyboard_arrow_down</span></button>
                  <ul className="nl-type-list">
                    <li><label className="nl-type-label"><input type="checkbox" /> Coles Supermarkets</label></li>
                    <li><label className="nl-type-label"><input type="checkbox" /> Coles Liquor</label></li>
                    <li><label className="nl-type-label"><input type="checkbox" /> Coles Express</label></li>
                  </ul>
                </li>
                <li>
                  <button type="button" className="nl-type-btn">Coles Business Brands <span className="material-symbols-outlined">keyboard_arrow_down</span></button>
                  <ul className="nl-type-list">
                    <li><label className="nl-type-label"><input type="checkbox" /> Coles Supermarkets</label></li>
                    <li><label className="nl-type-label"><input type="checkbox" /> Coles Liquor</label></li>
                    <li><label className="nl-type-label"><input type="checkbox" /> Coles Express</label></li>
                  </ul>
                </li>
                <li>
                  <button type="button" className="nl-type-btn">Coles Business Brands <span className="material-symbols-outlined">keyboard_arrow_down</span></button>
                  <ul className="nl-type-list">
                    <li><label className="nl-type-label"><input type="checkbox" /> Coles Supermarkets</label></li>
                    <li><label className="nl-type-label"><input type="checkbox" /> Coles Liquor</label></li>
                    <li><label className="nl-type-label"><input type="checkbox" /> Coles Express</label></li>
                  </ul>
                </li>
              </ul>

              <div className="news-room-sidebar">
                <div className="news-room-sidebar-box">
                  <div className="news-room-sidebar-title">Trending News</div>
                  <div className="trending-news-list">
                    <div className="trending-news-box">
                      <a href="#">
                        <div className="trending-news-img">
                          <img src="/images/article-img-1.jpg" alt="" />
                        </div>
                        <div className="trending-news-cnt">
                          <div className="trending-news-title">Have you ever tasted bourbon straight from the barrel?</div>
                          <div className="news-ul">
                            <div className="news-li"><span className="material-symbols-outlined">event_available</span> 04/08/2024</div>
                            <div className="news-li"><span className="material-symbols-outlined">visibility</span> 240 Views</div>
                          </div>
                        </div>
                      </a>
                    </div>
                    <div className="trending-news-box">
                      <a href="#">
                        <div className="trending-news-img">
                          <img src="/images/article-img-2.jpg" alt="" />
                        </div>
                        <div className="trending-news-cnt">
                          <div className="trending-news-title">Have you ever tasted bourbon straight from the barrel?</div>
                          <div className="news-ul">
                            <div className="news-li"><span className="material-symbols-outlined">event_available</span> 04/08/2024</div>
                            <div className="news-li"><span className="material-symbols-outlined">visibility</span> 240 Views</div>
                          </div>
                        </div>
                      </a>
                    </div>
                    <div className="trending-news-box">
                      <a href="#">
                        <div className="trending-news-img">
                          <img src="/images/article-img-3.jpg" alt="" />
                        </div>
                        <div className="trending-news-cnt">
                          <div className="trending-news-title">Have you ever tasted bourbon straight from the barrel?</div>
                          <div className="news-ul">
                            <div className="news-li"><span className="material-symbols-outlined">event_available</span> 04/08/2024</div>
                            <div className="news-li"><span className="material-symbols-outlined">visibility</span> 240 Views</div>
                          </div>
                        </div>
                      </a>
                    </div>
                    <div className="trending-news-box">
                      <a href="#">
                        <div className="trending-news-img">
                          <img src="/images/article-img-1.jpg" alt="" />
                        </div>
                        <div className="trending-news-cnt">
                          <div className="trending-news-title">Have you ever tasted bourbon straight from the barrel?</div>
                          <div className="news-ul">
                            <div className="news-li"><span className="material-symbols-outlined">event_available</span> 04/08/2024</div>
                            <div className="news-li"><span className="material-symbols-outlined">visibility</span> 240 Views</div>
                          </div>
                        </div>
                      </a>
                    </div>
                    <div className="trending-news-box">
                      <a href="#">
                        <div className="trending-news-img">
                          <img src="/images/article-img-2.jpg" alt="" />
                        </div>
                        <div className="trending-news-cnt">
                          <div className="trending-news-title">Have you ever tasted bourbon straight from the barrel?</div>
                          <div className="news-ul">
                            <div className="news-li"><span className="material-symbols-outlined">event_available</span> 04/08/2024</div>
                            <div className="news-li"><span className="material-symbols-outlined">visibility</span> 240 Views</div>
                          </div>
                        </div>
                      </a>
                    </div>
                    <div className="trending-news-box">
                      <a href="#">
                        <div className="trending-news-img">
                          <img src="/images/article-img-3.jpg" alt="" />
                        </div>
                        <div className="trending-news-cnt">
                          <div className="trending-news-title">Have you ever tasted bourbon straight from the barrel?</div>
                          <div className="news-ul">
                            <div className="news-li"><span className="material-symbols-outlined">event_available</span> 04/08/2024</div>
                            <div className="news-li"><span className="material-symbols-outlined">visibility</span> 240 Views</div>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>

                <div className="news-room-sidebar-box">
                  <div className="news-room-sidebar-title">Category</div>
                  <ul className="news-s-category-list p-0">
                    <li><a href="#">Category name <span>(24 News)</span></a></li>
                    <li><a href="#">Category name <span>(24 News)</span></a></li>
                    <li><a href="#">Category name <span>(24 News)</span></a></li>
                    <li><a href="#">Category name <span>(24 News)</span></a></li>
                    <li><a href="#">Category name <span>(24 News)</span></a></li>
                  </ul>
                </div>
              </div>

            </div>

            <div className="news-listing">
              <div className="news-listing-box">
                <div className="news-listing-img">
                  <img src="/images/article-img-1.jpg" alt="" />
                </div>
                <div className="news-listing-cnt">
                  <div className="news-l-left-cnt">
                    <div className="news-cnt-title">Have you ever tasted bourbon straight from the barrel?</div>
                    <div className="news-cnt-p">One of our whiskey experts will lead your group through a barrel tasting and pour, and will include information about the Bourbon.</div>
                    <div className="news-category-name"><span className="material-symbols-outlined">ballot</span> Relevant to Coles Liquor</div>
                  </div>
                  <div className="news-l-right-cnt">
                    <div className="news-ul">
                      <div className="news-li"><span className="material-symbols-outlined">person</span> Helena Thomton</div>
                      <div className="news-li"><span className="material-symbols-outlined">event_available</span> 04/08/2024</div>
                      <div className="news-li"><span className="material-symbols-outlined">visibility</span> 240 Views</div>
                    </div>
                    <Link to="/news-room-details/" className="red-more-btn">Read More</Link>
                  </div>
                </div>
              </div>
              <div className="news-listing-box">
                <div className="news-listing-img">
                  <img src="/images/article-img-2.jpg" alt="" />
                </div>
                <div className="news-listing-cnt">
                  <div className="news-l-left-cnt">
                    <div className="news-cnt-title">Have you ever tasted bourbon straight from the barrel?</div>
                    <div className="news-cnt-p">One of our whiskey experts will lead your group through a barrel tasting and pour, and will include information about the Bourbon.</div>
                    <div className="news-category-name"><span className="material-symbols-outlined">ballot</span> Relevant to Coles Liquor</div>
                  </div>
                  <div className="news-l-right-cnt">
                    <div className="news-ul">
                      <div className="news-li"><span className="material-symbols-outlined">person</span> Helena Thomton</div>
                      <div className="news-li"><span className="material-symbols-outlined">event_available</span> 04/08/2024</div>
                      <div className="news-li"><span className="material-symbols-outlined">visibility</span> 240 Views</div>
                    </div>
                    <a href="#" className="red-more-btn">Read More</a>
                  </div>
                </div>
              </div>
              <div className="news-listing-box">
                <div className="news-listing-img">
                  <img src="/images/article-img-3.jpg" alt="" />
                </div>
                <div className="news-listing-cnt">
                  <div className="news-l-left-cnt">
                    <div className="news-cnt-title">Have you ever tasted bourbon straight from the barrel?</div>
                    <div className="news-cnt-p">One of our whiskey experts will lead your group through a barrel tasting and pour, and will include information about the Bourbon.</div>
                    <div className="news-category-name"><span className="material-symbols-outlined">ballot</span> Relevant to Coles Liquor</div>
                  </div>
                  <div className="news-l-right-cnt">
                    <div className="news-ul">
                      <div className="news-li"><span className="material-symbols-outlined">person</span> Helena Thomton</div>
                      <div className="news-li"><span className="material-symbols-outlined">event_available</span> 04/08/2024</div>
                      <div className="news-li"><span className="material-symbols-outlined">visibility</span> 240 Views</div>
                    </div>
                    <a href="#" className="red-more-btn">Read More</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <SupplierCenteralFooter />
    </div>
  );
}